import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { LazyLoadEvent, Table, SelectItem } from 'primeng';
import { ICustomer } from '../../interfaces/customer';
import { IPageResult } from '../../interfaces/page-result';
import { ISelfBillingAgreement } from '../../interfaces/self-billing-agreement';
import { ISelfBillingAgreementFilter } from '../../interfaces/self-billing-agreement-filter';
import { SelfBillingAgreementService } from '../../services';
import { SupplierService } from '../../services';
import { MessageService } from 'primeng';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'manage-self-billing',
  templateUrl: './manage-self-billing.component.html',
})
export class ManageSelfBillingComponent implements OnInit {
  selectedAgreement: ISelfBillingAgreement;

  public page: IPageResult<ISelfBillingAgreement> = {
    items: [],
    total: 0,
  };
  public isLoaded: boolean = false;
  public filterVal: ISelfBillingAgreementFilter;
  public filter: Subject<ISelfBillingAgreementFilter>;

  selfBillingStatuses_withSelfBilling = 1;
  selfBillingStatuses_withoutSelfBilling = 2;
  selfBillingStatuses_ExpiringExpired = 3;

  public selfBillingStatuses = [
    { label: 'All Statuses', value: '0' },
    { label: 'With Self-Billing', value: this.selfBillingStatuses_withSelfBilling },
    { label: 'Without Self-Billing', value: this.selfBillingStatuses_withoutSelfBilling },
    { label: 'Expiring Or Expired', value: this.selfBillingStatuses_ExpiringExpired },
  ];

  private suppliersList: ICustomer[];
  supplierOpts: SelectItem[] = [];

  constructor(
    private selfBillingService: SelfBillingAgreementService,
    private supplierService: SupplierService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    public messageService: MessageService,
  ) {
    this.editingAgreementForm = fb.group({
      agreed: [null, Validators.required],
      commitedOn: [null, Validators.required],
    });
  }

  ngOnInit() {
    this.initDefaultFilter();

    this.filter = new Subject<ISelfBillingAgreementFilter>();
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });
    this.filter.next(this.filterVal);

    // this.initSupplierOptions();
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'expireStatus',
      sortOrder: -1,
      filters: {
        selfBillingStatus: { value: null },
      },
    };
  }

  load(filter: ISelfBillingAgreementFilter) {
    this.selfBillingService.getPage(filter).then((result) => {
      console.log(result);
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;
    // map grid lazy load event to filter
    this.filter.next(this.filterVal);
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filter.next(this.filterVal);
  }

  openSupplierDetails(item) {
    this.router.navigate(['app/organisations/' + item.organisationId]);
  }

  showEditAgreementDlg: boolean;
  editingAgreementForm: UntypedFormGroup;
  private _editingAgreement: any;

  editAgreement() {
    if (!this.selectedAgreement) return;

    this._editingAgreement = { ...this.selectedAgreement };
    this.editingAgreementForm.patchValue({
      agreed: this._editingAgreement.agreed,
      commitedOn:
        this._editingAgreement.commitedOn &&
        moment(this.selectedAgreement.commitedOn).utc().toDate(),
    });

    this.showEditAgreementDlg = true;
  }

  submitEditAgreement() {
    if (!this._editingAgreement) return;

    let toSave = Object.assign(this._editingAgreement, this.editingAgreementForm.value);
    let commitedOn = toSave.commitedOn;

    toSave.commitedOn = new Date(
      Date.UTC(commitedOn.getFullYear(), commitedOn.getMonth(), commitedOn.getDate()),
    ).toISOString();

    this.selfBillingService.update(toSave.organisationId, toSave).then(() => {
      Object.assign(this.selectedAgreement, toSave);
    });
  }

  onEditAgreementDlgHide() {
    this._editingAgreement = null;
    this.editingAgreementForm.reset();
  }

  // private initSupplierOptions(){
  //     this.supplierService.getForSelfBillingAgreements().then(res =>{
  //        this.supplierOpts = res.map(x => ({label: x.name, value: x.id}));
  //     });
  // }

  // showAddAgreementDlg: boolean;
  // supplierToAddId: number;
  //
  // addAgreement(){
  //     this.showAddAgreementDlg = true;
  // }
  //
  // submitAddAgreement(){
  //     if (!this.supplierToAddId) return;
  //     this.selfBillingService.createAgreement(this.supplierToAddId).then(() => {
  //         this.search()
  //         this.initSupplierOptions();
  //     })
  // }
  //
  // onAddAgreementDlgHide(){
  //     this.supplierToAddId = null;
  // }
}
